import React from 'react'

const SvgVideo = props => (
  <svg width="1em" height="1em" viewBox="0 0 98 98" fill="none" {...props}>
    <circle cx={49} cy={49} r={49} fill="url(#Video_svg__paint0_linear)" />
    <path
      d="M73.864 24H24.545A9.533 9.533 0 0 0 15 33.545v30.228a9.533 9.533 0 0 0 9.546 9.545h49.318a9.533 9.533 0 0 0 9.545-9.545V33.545A9.533 9.533 0 0 0 73.864 24zm3.818 39.773a3.83 3.83 0 0 1-3.818 3.818H24.545a3.83 3.83 0 0 1-3.818-3.818V33.545a3.83 3.83 0 0 1 3.819-3.818h49.318a3.83 3.83 0 0 1 3.818 3.818v30.228z"
      fill="#fff"
    />
    <path
      d="M55.473 46.973l-9.29-5.41c-.637-.381-1.4-.381-1.973 0-.637.383-1.019 1.019-1.019 1.719v10.69c0 .7.382 1.337 1.019 1.719.318.19.636.255 1.018.255.318 0 .7-.064 1.018-.255l9.29-5.346c.637-.381 1.019-1.018 1.019-1.718-.064-.7-.445-1.336-1.082-1.654zM29.764 34.246h-3.818c-.7 0-1.273.572-1.273 1.272v1.273c0 .7.573 1.273 1.273 1.273h3.818c.7 0 1.273-.573 1.273-1.273v-1.273c0-.7-.573-1.272-1.273-1.272zM29.764 42.582h-3.818c-.7 0-1.273.573-1.273 1.273v1.273c0 .7.573 1.272 1.273 1.272h3.818c.7 0 1.273-.572 1.273-1.273v-1.272c0-.7-.573-1.273-1.273-1.273zM29.764 50.918h-3.818c-.7 0-1.273.573-1.273 1.273v1.272c0 .7.573 1.273 1.273 1.273h3.818c.7 0 1.273-.573 1.273-1.273v-1.272c0-.7-.573-1.273-1.273-1.273zM29.764 59.254h-3.818c-.7 0-1.273.573-1.273 1.273V61.8c0 .7.573 1.273 1.273 1.273h3.818c.7 0 1.273-.573 1.273-1.273v-1.273c0-.7-.573-1.273-1.273-1.273zM72.654 34.246h-3.818c-.7 0-1.272.572-1.272 1.272v1.273c0 .7.572 1.273 1.272 1.273h3.818c.7 0 1.273-.573 1.273-1.273v-1.273c0-.7-.573-1.272-1.273-1.272zM72.654 42.582h-3.818c-.7 0-1.272.573-1.272 1.273v1.273c0 .7.572 1.272 1.272 1.272h3.818c.7 0 1.273-.572 1.273-1.273v-1.272c0-.7-.573-1.273-1.273-1.273zM72.654 50.918h-3.818c-.7 0-1.272.573-1.272 1.273v1.272c0 .7.572 1.273 1.272 1.273h3.818c.7 0 1.273-.573 1.273-1.273v-1.272c0-.7-.573-1.273-1.273-1.273zM72.654 59.254h-3.818c-.7 0-1.272.573-1.272 1.273V61.8c0 .7.572 1.273 1.272 1.273h3.818c.7 0 1.273-.573 1.273-1.273v-1.273c0-.7-.573-1.273-1.273-1.273z"
      fill="#fff"
    />
    <defs>
      <linearGradient
        id="Video_svg__paint0_linear"
        x1={30.625}
        y1={0}
        x2={84.28}
        y2={83.3}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#147FCD" />
        <stop offset={1} stopColor="#7EC5A3" />
      </linearGradient>
    </defs>
  </svg>
)

export default SvgVideo
